<template>
	<div class="fs3 bb1 bc7" @click.stop="$emit('node:select', node)">
		<div
			class="cu2 pt3 pb3 lh125 pl4 pr4"
			:class="node.isSelected ? 'c2 br4 bc2 fw6' : 'c6'"
		>{{ node.title }}</div>

		<template v-if="hasChildren">
			<steps-node
				v-for="(item, i) in node.children"
				:key="i"
				:node="item"
				v-on="$listeners"
			/>
		</template>
	</div>
</template>

<script>
export default {
	name: "StepsNode",
	props: { node: { type: Object } },
	computed: {
		hasChildren() {
			return this.node.children && this.node.children.length
		}
	}
}
</script>
